/**
 * 시간을 24시간 형식의 2자리 숫자로 포맷팅하는 함수
 * @param num - 포맷팅할 시간 문자열
 * @returns '00'~'23' 형식의 문자열
 */
const formatTime = (num: string): string => {
  const regexNumber = /^\d+$/;
  const isNumber = regexNumber.test(num);

  if (!isNumber) {
    return '00';
  }

  if (Number(num) <= 0) {
    return '00';
  }

  if (Number(num) < 10) {
    return num.padStart(2, '0');
  }

  if (24 < Number(num)) {
    return '23';
  }

  return num;
};

export default formatTime;
